module.exports = __webpack_public_path__ + "img/0Q3C0560.32e82fff.webp";